import { useState } from "react";

/**
 * StarRating — 0..5 star picker.
 * Props: value (number), onChange? (fn), readOnly, size ("sm"|"md"|"lg"), testIdPrefix
 */
export default function StarRating({ value = 0, onChange, readOnly = false, size = "md", testIdPrefix = "star" }) {
  const [hover, setHover] = useState(null);
  const shown = hover != null ? hover : value;
  const sizeCls = { sm: "text-lg", md: "text-2xl", lg: "text-4xl" }[size] || "text-2xl";
  return (
    <div className="inline-flex items-center gap-1 select-none" data-testid={`${testIdPrefix}-row`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = n <= shown;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            data-testid={`${testIdPrefix}-${n}`}
            onClick={() => !readOnly && onChange && onChange(n === value ? 0 : n)}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(null)}
            className={`${sizeCls} leading-none transition-transform ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} ${active ? "text-[#C77E3C]" : "text-[#D6CDBA]"}`}
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
          >
            {active ? "★" : "☆"}
          </button>
        );
      })}
    </div>
  );
}
